<script setup lang="ts">
import { useCustomizerStore } from '@/stores/customizer';
import Logo from '/public/images/logos/snapei-b2b-logo.svg';
import LogoLight from '/public/images/logos/snapei-b2b-logo-light.svg';

const customizer = useCustomizerStore();
const isDarkTheme = computed(() => customizer.actTheme === 'DARK_ORANGE_THEME');

const tabs = [
    { title: 'Pedidos', icon: 'mdi-clipboard-text', to: '/tat/picker/Pedidos' },
    { title: 'Historial', icon: 'mdi-history', to: '/tat/picker/Historial' },
];

const route = useRoute();
const activeTab = computed(() => tabs.find((tab) => tab.to === route.path)?.to ?? tabs[0].to);

// El menú inferior usa el sistema de "layout items" de Vuetify (mismo que
// v-app-bar) para calcular su posición fija — en cargas iniciales en
// viewports angostos (visto en Chrome DevTools modo responsive) ese cálculo
// queda desfasado y el menú no aparece hasta que se dispara un resize.
// DevTools tarda unos instantes en asentar las dimensiones del dispositivo
// emulado, así que un solo resize inmediato puede llegar antes de que el
// tamaño final esté listo — se repite con pequeños delays.
onMounted(() => {
    [0, 150, 500].forEach((delay) => {
        setTimeout(() => window.dispatchEvent(new Event('resize')), delay);
    });
});
</script>

<template>
  <v-locale-provider>
    <v-app class="tat-picker-layout" :theme="customizer.actTheme" :class="[customizer.actTheme]">
      <v-app-bar flat density="comfortable">
        <div class="d-flex align-center flex-grow-1" style="margin-left: 4px">
          <VImg :src="isDarkTheme ? LogoLight : Logo" height="40" width="123" style="flex: none" />
        </div>
        <div class="me-2">
          <LcFullVerticalHeaderThemeToggler />
        </div>
        <LcFullVerticalHeaderProfileDD />
      </v-app-bar>

      <v-main>
        <NuxtPage />
      </v-main>

      <v-bottom-navigation class="tat-bottom-nav" :model-value="activeTab" grow>
        <v-btn v-for="tab in tabs" :key="tab.to" :value="tab.to" :to="tab.to">
          <v-icon>{{ tab.icon }}</v-icon>
          <span>{{ tab.title }}</span>
        </v-btn>
      </v-bottom-navigation>
    </v-app>
  </v-locale-provider>
</template>

<style scoped>
.tat-bottom-nav {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
}
</style>
